import axios from 'axios';

window.requestPullToRefresh = (res) => {
};
window.requestPullToRefreshCallBack = (res) => {
};

const service = axios.create({
  baseURL: '/',
  timeout: 30000, // request timeout
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

service.interceptors.request.use((config) => config, (error) => {
  console.log(error);
  Promise.reject(error);
});

service.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

export default service;
